import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './dossier.action';

@Injectable({ providedIn: 'root' })
export class DossierTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '',
                created_at: '',
                dossier_id: '',
                debtor_name: '',
                dossier_categories_name: null,
                club_name: null,
                outstanding_status: '1',
                outstanding_with_fee: '',
                is_paid: null,
                season_name: ''
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubId = 0;
    memberId = 0;

    clubs = [];
    categories = [];
    statuses = [
        {id: "0", value: "DOSSIER.pending"},
        {id: "1", value: "DOSSIER.paid"},
        {id: "2", value: "DOSSIER.uncollectable"},
    ];

    outstandings = [
        {"id": "1", "name": "COMMON.yes"},
        {"id": "0", "name": "COMMON.no"}
    ];

    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'id', name: 'DOSSIER.dossier-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'debtor_name', name: 'DOSSIER.dossier-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'dossier_categories_name', name: 'DOSSIER.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name"},
                { prop: 'outstanding_status', name: 'DOSSIER.outstanding', sortable: true, hasFilter: true, filter: "select", options: 'outstandings', options_id: "id", options_label: "name"},
                { prop: 'outstanding_with_fee', name: 'DOSSIER.amount', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'is_paid', name: 'DOSSIER.payment-status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "value" },
                { prop: 'season_name', name: 'DOSSIER.season-name', sortable: true, hasFilter: true, filter: "input"}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({memberId: 0}));
    }

    hasActiveFilters(){
        if(
            Object.entries(this.filters).some(([key, value]) => {
                if (key === 'outstanding_status'){
                    return value != '1';
                }
                return value !== '' && value !== null;
            }) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            id: '',
            created_at: '',
            dossier_id: '',
            debtor_name: '',
            dossier_categories_name: null,
            club_name: null,
            outstanding_status: '1',
            outstanding_with_fee: '',
            is_paid: null,
            season_name: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}